Element.prototype.appendCollection = function (collection) {
  if (!(collection instanceof HTMLCollection || collection instanceof NodeList)) {
    throw new TypeError('Argument must be an HTMLCollection or NodeList');
  }
  Array.from(collection).forEach((element) => this.append(element));
  return this;
};

(function (global) {
  const originalCheckValidity = HTMLFormElement.prototype.checkValidity;

  HTMLFormElement.prototype.asyncCheckValidity = function () {
    const isValid = originalCheckValidity.call(this);

    return new Promise((resolve) => {
      // Сбор данных о форме
      const formData = {
        form: this,
        fields: Array.from(this.elements).map((field) => ({
          name: field.name,
          value: field.value,
          isValid: field.checkValidity(),
          validationMessage: field.validationMessage
        })),
        isValid
      };

      // Создаем пользовательское событие
      const validityEvent = new CustomEvent('checkValidity', {
        bubbles: true,
        cancelable: true,
        detail: formData
      });

      // Генерация события и проверка на прерывание
      const defaultPrevented = !this.dispatchEvent(validityEvent);

      // Возвращаем результат
      resolve(!defaultPrevented && isValid);
    });
  };

  Element.prototype.closestAttribute = function (attributeName) {
    let element = this; // Начинаем с текущего элемента

    while (element) {
      if (element.hasAttribute(attributeName)) {
        return element; // Возвращаем элемент, если у него есть указанный атрибут
      }
      element = element.parentElement; // Поднимаемся вверх по DOM-дереву
    }

    return null; // Если не найден, возвращаем null
  };

  Element.prototype.closestProperty = function (propertyName, parent = false) {
    let element = !parent ? this : this.parentElement;

    while (element) {
      if (propertyName in element) {
        return element; // Возвращаем элемент, если свойство существует
      }
      element = element.parentElement; // Поднимаемся вверх по DOM-дереву
    }

    return null; // Если не найдено, возвращаем null
  };

  Element.prototype.reload = function (options = {}) {
    let element = this; // Начинаем с текущего элемента

    const reloadContainer = element.closestProperty('reloader');

    if (reloadContainer) {
      return reloadContainer.reloader(options);
    }

    throw new Error('Не найден загрущик');
  };

  Element.prototype.close = function (options = {}) {
    let element = this; // Начинаем с текущего элемента

    const closeContainer = element.closestProperty('closer');

    if (closeContainer) {
      return closeContainer.closer(options);
    }

    throw new Error('Не найден closer');
  };

  Element.prototype.sortUpdate = function (attributeName) {
    let element = this; // Начинаем с текущего элемента

    const reloadContainer = element.closestProperty('sortUpdater');

    if (reloadContainer) {
      return reloadContainer.sortUpdater();
    }

    return false;
  };

  Element.prototype.reloadGlobal = function (options = {}) {
    let element = this; // Начинаем с текущего элемента

    let reloadContainer = element.closestProperty('reloader');

    if (!reloadContainer) {
      return location.reload(options);
    }

    while (reloadContainer.closestProperty('reloader', true)) {
      reloadContainer = reloadContainer.closestProperty('reloader', true);
    }

    return reloadContainer.reloader(options);
  };

  Element.prototype.modalManager = function () {
    const element = this;
    const modal = element.closest('.modal');

    if (!modal) {
      throw new Error('Не найдено модальное окно');
    }

    if (!modal.modalManager) {
      throw new Error('Не найден ModalManager');
    }

    return modal.modalManager;
  };

  Element.prototype.closestParentWith = function (selector) {
    let parent = this.parentElement;
    while (parent) {
      if (parent.querySelector(selector)) return parent;
      parent = parent.parentElement;
    }
    return null;
  };

  // Сохраняем нативные методы
  const nativeInputClick = HTMLInputElement.prototype.click;
  const nativeLabelClick = HTMLLabelElement.prototype.click;

  // Переопределяем click для input
  HTMLInputElement.prototype.click = function (...args) {
    if (this.getAttribute('type') === 'checkbox-tri') {
      const states = ['false', 'inherited', 'true',];

      // Функция нормализации значения
      const normalizeValue = (value) => {
        if (value === null || value === undefined || value === '') return 'false';

        // Приведение к строке для унификации
        const strValue = String(value).toLowerCase().trim();

        // Проверяем на true-подобные значения
        if (['1', 'true', 'on'].includes(strValue)) return 'true';

        // Проверяем на false-подобные значения
        if (['0', 'false', 'off'].includes(strValue)) return 'false';

        // Проверяем на inherited
        if (strValue === 'inherited') return 'inherited';

        // По умолчанию false
        return 'false';
      };

      // Получаем текущее значение и нормализуем его
      const currentValue = normalizeValue(this.getAttribute('value'));

      // Находим индекс в массиве состояний
      let current = states.indexOf(currentValue);
      if (current === -1) current = 0; // Fallback на 'false'

      // Переключаем на следующее состояние
      const next = (current + 1) % states.length;
      this.setAttribute('value', states[next]);
      this.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    return nativeInputClick.apply(this, args);
  };

  // Переопределяем click для label
  HTMLLabelElement.prototype.click = function (...args) {
    const forId = this.getAttribute('for');
    if (forId) {
      const input = document.getElementById(forId);
      if (input && input.getAttribute('type') === 'checkbox-tri') {
        input.click();
        return;
      }
    }
    return nativeLabelClick.apply(this, args);
  };

  // Перехватываем клики только на checkbox-tri элементах
  document.addEventListener('click', function (e) {
    let target = e.target;

    // Проверяем, является ли цель или её родитель checkbox-tri или связанный label
    const triInput = target.getAttribute('type') === 'checkbox-tri' ? target : null;
    const triLabel = target.tagName === 'LABEL' && target.getAttribute('for') ?
      document.getElementById(target.getAttribute('for')) : null;
    const parentTriLabel = target.closest('label[for]');
    const parentTriInput = parentTriLabel ? document.getElementById(parentTriLabel.getAttribute('for')) : null;

    // Если это checkbox-tri или его label
    if ((triInput || (triLabel && triLabel.getAttribute('type') === 'checkbox-tri') ||
      (parentTriInput && parentTriInput.getAttribute('type') === 'checkbox-tri'))) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Вызываем клик на нужном элементе
      if (triInput) {
        triInput.click();
      } else if (triLabel && triLabel.getAttribute('type') === 'checkbox-tri') {
        triLabel.click();
      } else if (parentTriInput && parentTriInput.getAttribute('type') === 'checkbox-tri') {
        parentTriInput.click();
      }
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.target instanceof HTMLTextAreaElement && e.shiftKey && e.key === 'Enter') {
      e.preventDefault();
      e.target.setRangeText('\n', e.target.selectionStart, e.target.selectionEnd, 'end');
      e.target.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });

  Element.prototype.closestInParent = function (selector) {
    let parent = this.parentElement;
    while (parent) {
      if (parent.querySelector(selector)) return parent.querySelector(selector);
      parent = parent.parentElement;
    }
    return null;
  };
})(window);
